/**
 * property action
 *
 */
import {
    USER_GET_USERS,
    USERS_GET_SELECTED_USER,
    USERS_CHANGE_FIELD,
    SAVE_FILE,
    USERS_UPDATE_USER,
    USERS_DELETE_USER,
    USERS_SEND_FILE
} from './types'

export const usersGetUsers = (pageNumber = 1, entriesPerPage = 10) => {
    return {
        type: USER_GET_USERS,
        payload: {
            request: {
                method: 'GET',
                url: `/users?pageNumber=${pageNumber}&entriesPerPage=${entriesPerPage}`,
            }
        }
    }
}
export const usersChangeField = (name, value) => {
    return {
        type: USERS_CHANGE_FIELD,
        name,
        value
    }
}
export const usersGetSelectedUser = (user) => {
    return {
        type: USERS_GET_SELECTED_USER,
        user
    }
}
export const saveFile = (data) => {
    return {
        type: SAVE_FILE,
        payload: {
            request: {
                method: 'POST',
                url: `/files`,
                data: data,
            }
        }
    }
}
export const usersUpdateUser = (userId, data) => {
    return {
        type: USERS_UPDATE_USER,
        payload: {
            request: {
                method: 'PATCH',
                url: `/user/${userId}`,
                data: data,
            }
        }
    }
}
export const usersDeleteUser = (userId) => {
    return {
        type: USERS_DELETE_USER,
        payload: {
            request: {
                method: 'DELETE',
                url: `/user/${userId}`,
            }
        }
    }
}
export const usersSendFile = (userId,data) => {
    return {
        type: USERS_SEND_FILE,
        payload: {
            request: {
                method: 'POST',
                url: `/files/user/${userId}`,
                data
            }
        }
    }
}